import { PathType } from "./PathType";
import Home from '../../../../../assets/home.svg';
import Home2 from '../../../../../assets/home_active.svg';
import History from '../../../../../assets/history.svg';
import Mediacal_emergency from '../../../../../assets/pulse_alert.svg';
import Mediacal_emergency2 from '../../../../../assets/pulse_alert_active.svg';
import Initiat_Mediacal_emergency from '../../../../../assets/mediacal-emerency.svg';
import Initiat_Mediacal_emergency2 from '../../../../../assets/mediacal-emerency_active.svg';


export const EmsPaths: PathType[] = [
      {
        path: "/medical-emergencies",
        label: "Home",
        icon: Home,
        icon_active: Home2
      },
      {
        path: "/ems/medical-emergencies",
        label: "Active Incidents",
        icon: Mediacal_emergency,
        icon_active: Mediacal_emergency2
      },
      {
        path: "/ems/medical-emergencies/history",
        label: "History",
        icon: History,
        icon_active: History
      },
      {
        path: "/ems/medical-emergencies/initiate-medical",
        label: "Initiate Medical Event",
        icon: Initiat_Mediacal_emergency,
        icon_active: Initiat_Mediacal_emergency2
      }
     
];

// export const EmsPaths: PathType[] = [
//   {
//     path: "/medical-emergencies",
//     label: "Home",
//     icon: Home,
//     subPaths: [
//       {
//         path: "/ems/medical-emergencies",
//         label: "Medical Emergencies",
//         icon: Mediacal_emergency,
//       },
//       {
//         path: "/ems/medical-emergencies/history",
//         label: "History",
//         icon: History,
//       },
//       {
//         path: "/ems/medical-emergencies/initiate-medical",
//         label: "Initiate Medical Event",
//         icon: Mediacal_emergency,
//       }
//     ],
//   },
// ];
